
// import { thirdGrant } from "@/api/login";
// import { setToken } from "@/utils/token";

export default {
    data() {
        return {
            fullscreenLoading: true
        }
    },
    created() {
        this.getWinXinCode()
    },
    methods: {
        getWinXinCode() {
            let params = {
                action: {
                    thirdType: 'WECHAT',
                    authCode: this.$route.query.code
                }
            }
            this.$api.thirdGrant(params).then((res) => {
                this.fullscreenLoading = false
                if (res.success) {
                    let data = res.data
                    // 通过微信扫码但没有绑定手机
                    if (!data.isBind) {
                        this.$message.success('微信授权成功，为了您的安全请绑定手机号码完成注册')
                        // 存第三方参数值
                        this.$store.commit('user/THIRD_USERINFO', data)
                        this.$router.push('/registered')
                    } else {
                        this.$api.getImInfo().then(({ success, data }) => {
                            if (success) {
                                this.$store.dispatch('ry/initConnect', data)
                            }
                        })
                        // 如果绑定了手机就直接登录
                        // setToken(data.token); //存在cookie中
                        this.$cookies.set('pzdsCookie', data.token)
                        this.$router.push('/')
                    }
                } else {
                    this.$confirm('出错了，请重新进行微信扫码授权...', '警告', {
                        confirmButtonText: '确定',
                        type: 'error',
                        center: true
                    })
                        .then(() => {
                            this.$router.push({ path: '/login', params: { openCode: true } })
                        })
                        .catch(() => {
                            this.$router.push({ path: '/login', params: { openCode: true } })
                        })
                }
            })
        }
    }
}
